import React from 'react';
import { Link } from 'react-router-dom';
import LMSHeader from '../components/LMSHeader';

const OrganizationLandingPage = () => {

  const successStats = [
    { number: "250+", label: "Oil & Gas Companies Trained" },
    { number: "15K+", label: "Employees Certified" },
    { number: "98%", label: "Compliance Pass Rate" },
    { number: "₦450M+", label: "Total Training Value Delivered" }
  ];

  return (
    <>
    <LMSHeader/>
      {/* Hero Section */}
      <section className="relative py-20 md:py-32 bg-gradient-to-br from-primary-600 via-blue-700 to-indigo-800 text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <img 
            src="https://placehold.co/1920x1080/1e40af/ffffff?text=Oil+&+Gas+Training" 
            alt="Hero Background"
            className="w-full h-full object-cover"
          />
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
            Transform Your Workforce with
            <span className="block text-primary-200">Industry-Leading Oil & Gas Training</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed">
            Empower your employees with expert-led, compliance-ready courses designed for Nigeria's energy sector.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/org/register"
              className="px-8 py-4 bg-white text-primary-600 font-medium text-lg rounded-lg shadow-lg hover:bg-neutral-100 transition-transform transform hover:scale-105 hover:shadow-xl"
            >
              Register Your Organization
            </Link>
            <Link
              to="/courses"
              className="px-8 py-4 bg-transparent border-2 border-white text-white font-medium text-lg rounded-lg hover:bg-white hover:text-primary-600 transition-transform transform hover:scale-105 hover:shadow-lg"
            >
              Browse Courses
            </Link>
          </div>
          
          {/* Trust Indicators */}
          <div className="mt-12 flex flex-wrap justify-center gap-8 text-sm">
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118l-2.8-2.034c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
              <span>4.9/5 Average Rating</span>
            </div>
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
              <span>Certificate of Completion</span>
            </div>
            <div className="flex items-center">
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" />
              </svg>
              <span>DNV-GL & NUPRC Compliant</span>
            </div>
          </div>
        </div>

        {/* Floating Elements */}
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary-600 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-primary-600 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob animation-delay-2000"></div>
      </section>

      {/* Stats Section */}
      <section className="py-16 bg-gradient-to-r from-primary-500 to-primary-600 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            {successStats.map((stat, i) => (
              <div key={i} className="bg-white bg-opacity-20 backdrop-blur-sm rounded-lg p-6 shadow-lg">
                <div className="text-3xl md:text-4xl font-bold mb-1">{stat.number}</div>
                <div className="text-sm md:text-base opacity-90">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-neutral-50 dark:bg-neutral-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-neutral-900 dark:text-white mb-4">Why Choose BoleumLearn for Corporate Training?</h2>
            <p className="text-xl text-neutral-600 dark:text-neutral-400">Discover what makes our platform the best choice for oil & gas companies</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <FeatureCard
              icon="🎓"
              title="Certified Industry Experts"
              description="All courses are created and taught by certified HSE, drilling, and engineering professionals."
            />
            <FeatureCard
              icon="✅"
              title="Regulatory Compliance"
              description="Our curriculum meets SON, NUPRC, and international safety standards for offshore operations."
            />
            <FeatureCard
              icon="📊"
              title="Real-Time Progress Tracking"
              description="Monitor employee progress, completion rates, and certification status from a centralized dashboard."
            />
            <FeatureCard
              icon="💼"
              title="Custom Learning Paths"
              description="Create tailored training programs for different roles — Drilling Engineers, Field Operators, Safety Officers."
            />
            <FeatureCard
              icon="💳"
              title="Flexible Pricing & Offers"
              description="Get free/discounted seats on bulk enrollment or special admin offers."
            />
            <FeatureCard
              icon="📜"
              title="Branded Certificates"
              description="Certificates feature your company logo and signatory for internal recognition and audit readiness."
            />
          </div>
        </div>
      </section>

      {/* Testimonials Carousel */}
      <section className="py-16 bg-white dark:bg-neutral-800">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-center text-neutral-900 dark:text-white mb-12">
            Trusted by Leading Energy Firms
          </h2>
          <div className="overflow-hidden">
            <div className="flex space-x-6 animate-scroll">
              {[
                { name: "Shell Nigeria", quote: "BoleumLearn helped us achieve 100% HSE certification across all field staff." },
                { name: "NNPC Technical Services", quote: "The custom learning paths saved us over 600 training hours annually." },
                { name: "TotalEnergies NG", quote: "Compliance audits are now seamless thanks to detailed analytics." },
                { name: "Chevron Nigeria", quote: "High-quality content delivered at scale — exactly what we needed." }
              ].map((testimonial, i) => (
                <div key={i} className="min-w-[300px] flex-shrink-0 bg-neutral-50 dark:bg-neutral-700 p-6 rounded-lg shadow-md">
                  <p className="italic text-neutral-700 dark:text-neutral-300 mb-4">"{testimonial.quote}"</p>
                  <p className="font-semibold text-primary-600 dark:text-primary-400">{testimonial.name}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-primary-50 dark:bg-primary-900/30">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-neutral-900 dark:text-white mb-6">
            Ready to Upskill Your Team?
          </h2>
          <p className="text-xl text-neutral-600 dark:text-neutral-400 mb-8">
            Join hundreds of organizations using BoleumLearn to meet regulatory requirements and build a safer, more skilled workforce.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/org/register"
              className="px-8 py-4 bg-primary-600 hover:bg-primary-700 text-white font-medium text-lg rounded-lg shadow-lg transition-all duration-200"
            >
              Get Started as Organization
            </Link>
            <Link
              to="/contact"
              className="px-8 py-4 bg-transparent border-2 border-primary-600 text-primary-600 hover:bg-primary-600 hover:text-white font-medium text-lg rounded-lg transition-all duration-200"
            >
              Schedule a Demo
            </Link>
          </div>
        </div>
      </section>

      {/* Footer Call-to-Action */}
      <section className="py-16 bg-neutral-900 text-white">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold mb-4">Start Training Today</h2>
          <p className="text-lg text-gray-300 mb-6">
            Register your organization and begin enrolling employees in high-impact courses immediately.
          </p>
          <Link
            to="/org/register"
            className="inline-block px-8 py-4 bg-primary-500 hover:bg-primary-600 text-white font-medium text-lg rounded-lg shadow-lg transition"
          >
            Register Now
          </Link>
        </div>
      </section>
    </>
  );
};

// Reusable Feature Card Component
const FeatureCard = ({ icon, title, description }) => (
  <div className="bg-white dark:bg-neutral-800 rounded-lg shadow-sm p-6 hover:shadow-md transition transform hover:-translate-y-1">
    <div className="text-5xl mb-4">{icon}</div>
    <h3 className="text-xl font-semibold text-neutral-900 dark:text-white mb-3">{title}</h3>
    <p className="text-neutral-600 dark:text-neutral-400">{description}</p>
  </div>
);

export default OrganizationLandingPage;